import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
} from "@material-ui/core"
import SelectMaterial from "@material-ui/core/Select"
import { Autocomplete } from"@material-ui/lab"
import AddIcon from "@material-ui/icons/Add"
import GoogleMapLocation from "../../components/GoogleMapLocation"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import ImageSelector from '../../components/ImageSelector/ImageSelector'
import { actionSaveNovelty } from '../../actions/NoveltyActions'
import moment from 'moment'
let _handleSubmitFail;
class AddEditNovelty extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={imgEdit:null, imgNameEdit:null}
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    
    if(this.props.isEditing){
      let novelty=this.props.history.location.state//this.props.novelty
      console.log("NOVELTY", novelty)
      if(novelty){  
        novelty.nvtDate = novelty.nvtDate&&Util.timestampToMoment(novelty.nvtDate).format('YYYY-MM-DDTHH:mm')
        this.props.initialize(novelty)
        this.setState({imgEdit:novelty.nvtImg, imgNameEdit:novelty.nvtNameImg})
      }else{
        this.props.history.replace(LOGIN_ROUTE);
      }
    }else{
      this.props.initialize({nvtDiffusion:"public" ,nvtNotify:false})
    }
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onClean(){
    if(this.props.isEditing){
      let novelty=this.props.novelty
      this.props.initialize({tskStatus:"scheduled", nvtNotificationId:novelty.notificationId, nvtPathImg:novelty.nvtPathImg})
    }else{
      this.props.initialize({nvtDiffusion:"public" ,nvtNotify:false})
    }
    this.setState({imgEdit:null, imgNameEdit:null})
  }

  onSave(formValues){
    this.props.actionSaveNovelty(formValues
      , ()=>{Util.showNoty(SUCCESS, "La novedad se guardó correctamente."); this.props.history.goBack()}
      , (e)=>{
        console.log("ERROR ON SAVE NOVELTY", e)
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No se pudo guardar la novedad.")
      }
    )
  }

  render(){
    const { theme, handleSubmit, isEditing } = this.props
    const title = isEditing?"Editar Novedad":"Crear Novedad"
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Crear Novedad</Typography>
            <Typography variant="subtitle1">Crea Novedad</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Typography style={theme.paper.title} variant="h2">{title}</Typography>
            <form style={theme.paper.form}>
              <Grid container xs={12} spacing={3} direction="row">
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    name="nvtTitle"
                    label="Título de la novedad"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="nvtDate"
                    label="Fecha de publicación"
                    type="datetime-local"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    validate={[required]}
                  />
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel shrink>Difusión</InputLabel>
                    <Field
                      component={Select}
                      select
                      name="nvtDiffusion"
                      fullWidth
                      validate={[required]}
                    >
                      <MenuItem value="public">PÚBLICA</MenuItem>
                      <MenuItem value="private">PRIVADA</MenuItem>
                    </Field>  
                  </Grid>
                  <Grid item xs={1}>
                    <InputLabel shrink>Notificar</InputLabel>
                    <Field
                      component={Select}
                      select
                      name="nvtNotify"
                      fullWidth
                      validate={[required]}
                    >
                      <MenuItem value={true}>SI</MenuItem>
                      <MenuItem value={false}>NO</MenuItem>
                    </Field>  
                  </Grid>
              </Grid>
              <Grid container direction="row" spacing={3}>
                <Grid item xs={4}>
                  <ImageSelector
                    fieldName="nvtImg"
                    // validate={[required]}
                    fileDimentions={{ width: 750, height: 370 }}
                    styleButton={theme.imageSelector}
                    imagePreviewUrl={this.state.imgEdit}
                    fileName={this.state.imgNameEdit}
                    fileSize={300000}
                    showDelete={true}
                    noPreview
                  />
                </Grid>
                  <Grid item xs={8}>
                    <Field
                      component={TextField}
                      name="nvtDescription"
                      label="Descripción"
                      fullWidth
                      multiline
                      rows={4}
                      validate={[required]}
                    />
                </Grid>
                
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  // console.log("STORE EVENT", store)
  return {
    login: store.auth.login,
    novelty: store.nvt.novelty
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveNovelty,
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditNews",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditNovelty)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/news/AddEditNovelty.js